import { Vendor } from "@/types/vendor";

const STORAGE_KEYS = {
    VENDORS: 'vendors',
  } as const;
  
  type VendorUpdateCallback = (vendors: any[]) => void;
  const subscribers = new Set<VendorUpdateCallback>();
  
  export function getStoredVendors(): Vendor[] {
    const vendors = localStorage.getItem(STORAGE_KEYS.VENDORS);
    return vendors ? JSON.parse(vendors) : [];
  }
  
  export function addStoredVendor(vendor: unknown): Vendor {
    const vendors = getStoredVendors();
    vendors.push(vendor as Vendor);
    localStorage.setItem(STORAGE_KEYS.VENDORS, JSON.stringify(vendors));
    notifySubscribers(vendors);
    return vendor as Vendor;
  }
  
  export function updateStoredVendor(vendor: unknown) {
    const vendors = getStoredVendors();
    const index = vendors.findIndex((v: any) => v.id === (vendor as any).id);
    if (index !== -1) {
      vendors[index] = vendor as Vendor;
      localStorage.setItem(STORAGE_KEYS.VENDORS, JSON.stringify(vendors));
      notifySubscribers(vendors);
    }
    return vendor;
  }
  
  export function deleteStoredVendor(vendorId: string) {
    const vendors = getStoredVendors();
    const filteredVendors = vendors.filter((v: any) => v.id !== vendorId);
    localStorage.setItem(STORAGE_KEYS.VENDORS, JSON.stringify(filteredVendors));
    notifySubscribers(filteredVendors);
  }
  
  function notifySubscribers(vendors: unknown[]) {
    subscribers.forEach(callback => callback(vendors));
  }
  
  export function subscribeToVendorUpdates(callback: VendorUpdateCallback) {
    subscribers.add(callback);
    return () => {
      subscribers.delete(callback);
    };
  }
  
  export function clearStoredVendors() {
    localStorage.removeItem(STORAGE_KEYS.VENDORS);
    notifySubscribers([]);
  }